/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    description?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeToJSON(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'type': value.type,
        'description': value.description,
    };
}

